<template>
<v-container class="text-center px-5">
  <v-row>
    <v-col>
      <v-btn-toggle v-model="source" mandatory>
        <v-btn small value="film">Film Rating</v-btn>
        <v-btn small value="user">User's Rating</v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-btn-toggle v-model="type" mandatory>
        <v-btn small value="none" :disabled="source == 'film'">None</v-btn>
        <v-btn small value="exact">Exact</v-btn>
        <v-btn small value="atleast">At Least</v-btn>
        <v-btn small value="atmost">At Most</v-btn>
        <v-btn small value="between">Between</v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
  <v-row v-if="type != 'none'">
    <v-col>
      <v-rating dense length="10">
        <template #item="{ index }">
          <v-icon
            :color="getColor(index)"
            @click="clicked(index)"
          >mdi-star</v-icon>
        </template>
      </v-rating>
    </v-col>
  </v-row>
  <v-row v-if="source == 'user'">
    <v-col>
      <v-autocomplete
        v-model="user"
        hide-no-data
        hide-selected
        label="By"
        :items="users"
      />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: "RatingFilterBuilder",
  data() {
    return {
      source: "film",
      type: "exact",
      exact: 0,
      atLeast: 10,
      atMost: 0,
      // 0: non selected, 1: first value select, 2: both values selected
      betweenState: 0,
      user: "",
      users: [],
    }
  },
  inject: ["httpClient"],
  async mounted() {
    this.users = (await this.httpClient.loadAllUsers()).map(u => u.name)
  },
  methods: {
    getColor(index) {
      if (this.type == "exact") {
        return this.exact === index + 1 ? "orange" : "gray"
      }
      if (this.type == "atleast") {
        return this.atLeast <= index + 1 ? "orange" : "gray"
      }
      if (this.type == "atmost") {
        return this.atMost >= index + 1 ? "orange" : "gray"
      }
      if (this.type == "between") {
        if (this.betweenState === 0) {
          return "gray"
        }
        if (this.betweenState === 1) {
          return this.atLeast === index + 1 ? "orange" : "orange lighten-3"
        }
        if (this.betweenState === 2) {
          return this.atLeast <= index + 1 && this.atMost >= index + 1 ? "orange" : "gray"
        }
      }
      return "green"
    },
    clicked(index) {
      if (this.type == "exact") {
        this.exact = this.exact === index + 1 ? 0 : index + 1
      } else
      if (this.type == "atleast") {
        this.atLeast = this.atLeast === index + 1 ? 10 : index + 1
      } else
      if (this.type == "atmost") {
        this.atMost = this.atMost === index + 1 ? 0 : index + 1
      } else
      if (this.type == "between") {
        if (this.betweenState === 0) {
          this.atLeast = index+1
          this.betweenState = 1
        } else if(this.betweenState === 1) {
          if (this.atLeast < index+1) {
            this.atMost = index+1
            this.betweenState = 2
          } else if (this.atLeast > index+1) {
            this.atMost = this.atLeast
            this.atLeast = index+1
            this.betweenState = 2
          } else {
            this.betweenState = 0
          }
        } else {
          if (this.atLeast > index+1) {
            this.atLeast = index+1
          } else if(this.atMost < index+1) {
            this.atMost = index+1
          } else {
            this.betweenState = 0
          }
        }
      }
    },

    init() {
      this.source = "film"
      this.type = "exact"
      this.exact = 0
      this.atLeast = 10
      this.atMost = 0
      this.betweenState = 0
      this.user = ""
    },
    build(negate) {
      const prefix = negate ? "not " : ""
      const op = negate ? "or" : "and"
      var postfix = ""
      if (this.source == "user") {
        if (!this.user) return [null, "You need to select a user"]
        postfix = ` by ${this.user}`
      }
      switch (this.type) {
        case "none":
          return [`${prfix}rated` + postfix]
        case "exact":
          return [`${prefix}rated ${this.exact}` + postfix]
        case "atleast":
          return [`${prefix}rated ${this.atLeast} plus` + postfix]
        case "atmost":
          return [`${prefix}rated ${this.atMost} minus` + postfix]
        case "between":
          return [`${prefix}rated ${this.atLeast} plus` + postfix +
                  ` ${op} ${prefix}rated ${this.atMost} minus` + postfix]
      }
    },
  },
  watch: {
    source(val) {
      if (val == "film" && this.type == "none") this.type = "exact"
    },
  },
}
</script>
